import { ObservableSubscription } from "@apollo/client";
import { createContext } from "react";

export type AbortableRequestsContextType = {
    setAbortableRequest: (channel: string, id: string, fireRequest: () => ObservableSubscription) => void;
    abortPendingRequest: (channel: string, id: string) => void;
    pauseIncomingRequests: (channel: string, id: string) => string;
    resumeIncomingRequests: (channel: string, id: string, identifier: string) => void;
}

export const AbortableRequestsContext = createContext({} as AbortableRequestsContextType);
AbortableRequestsContext.displayName = "AbortableRequests";
